import { render, staticRenderFns } from "./Restoration4.vue?vue&type=template&id=8e31ae68&scoped=true"
import script from "./Restoration4.vue?vue&type=script&lang=js"
export * from "./Restoration4.vue?vue&type=script&lang=js"
import style0 from "./Restoration4.vue?vue&type=style&index=0&id=8e31ae68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e31ae68",
  null
  
)

export default component.exports